import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import {
  BaseNewRequestControlName,
  InvestorDetailsNewRequestFormGroup,
} from '../../../../shared/base-new-request-form/base-new-request-form.model';
import { NgbDateRange } from '../../../../utils/date-helper/date-helper.util';
import { MCGRFinancialSectorApplicationFormGroup } from '../../financial-sector-application-form-array/financial-sector-application-form-array.model';
import { MCGROtherConservationActivitiesFormGroup } from '../../other-conservation-activities-form-array/other-conservation-activities-form-array.model';
import { MCGREstimatedWorksCostsFormGroup } from '../../works-estimated-costs/works-estimated-costs-form.model';
import { MCGRConstructionPermitDocumentType } from '../new-request/new-request.model';

export enum MCGRNewRequestAdditionalControlName {
  TaskName = 'taskName',
  MonumentName = 'monumentName',
  MonumentRegistryNumber = 'monumentRegistryNumber',
  MonumentRegistryDate = 'monumentRegistryDate',
  DeterminationOfLocation = 'determinationOfLocation',
  JustificationOfImportance = 'justificationOfImportance',
  ContactPerson = 'contactPerson',
  ApplicantAccountNumber = 'applicantAccountNumber',
  LegalTitleToMonument = 'legalTitleToMonument',
  LandAndMortgageRegisterNumberAndDocumentsCollectionNumber = 'landAndMortgageRegisterNumberAndDocumentsCollectionNumber',
  ConservationPermit = 'conservationPermit',
  ConstructionPermit = 'constructionPermit',
  ScopeOfWorks = 'scopeOfWorks',
  JustificationOfWorksPurpose = 'justificationOfWorksPurpose',
  WorksDateRange = 'worksDateRange',
  FinancialSectorApplication = 'financialSectorApplication',
  WorksEstimatedCosts = 'worksEstimatedCosts',
  MonumentCare = 'monumentCare',
  HasBuildingBook = 'hasBuildingBook',
  HasAnnualTechInspections = 'hasAnnualTechInspections',
  HasFiveYearTechInspections = 'hasFiveYearTechInspections',
  OtherActivities = 'otherActivities',
  OtherConservationActivities = 'otherConservationActivities',
  ExpenditureDeclaration = 'expenditureDeclaration',
  AwarenessAndTruthfulnessDeclaration = 'awarenessAndTruthfulnessDeclaration',
}

export enum MCGRPermitFormControlName {
  IssuedBy = 'issuedBy',
  Date = 'date',
  Number = 'number',
  Type = 'type',
}

export enum MCGRLandAndMortgageRegisterNumberAndDocumentsCollectionNumberFormControlName {
  LandAndMortgageRegisterNumber = 'landAndMortgageRegisterNumber',
  DocumentsCollectionNumber = 'documentsCollectionNumber',
}

export const MCGRNewRequestControlName = {
  ...BaseNewRequestControlName,
  ...MCGRNewRequestAdditionalControlName,
};

export interface MCGRConservationPermitFormGroup {
  [MCGRPermitFormControlName.IssuedBy]: FormControl<string>;
  [MCGRPermitFormControlName.Date]: FormControl<NgbDate>;
  [MCGRPermitFormControlName.Number]: FormControl<string>;
}

export interface MCGRConstructionPermitFormGroup
  extends MCGRConservationPermitFormGroup {
  [MCGRPermitFormControlName.Type]: FormControl<MCGRConstructionPermitDocumentType>;
}

export interface MCGRLandAndMortgageRegisterNumberAndDocumentsCollectionNumberFormGroup {
  [MCGRLandAndMortgageRegisterNumberAndDocumentsCollectionNumberFormControlName.LandAndMortgageRegisterNumber]: FormControl<string>;
  [MCGRLandAndMortgageRegisterNumberAndDocumentsCollectionNumberFormControlName.DocumentsCollectionNumber]: FormControl<string>;
}

export interface MCGRNewRequestFormGroup
  extends InvestorDetailsNewRequestFormGroup {
  [MCGRNewRequestControlName.TaskName]: FormControl<string>;
  [MCGRNewRequestControlName.MonumentName]: FormControl<string>;
  [MCGRNewRequestControlName.MonumentRegistryNumber]: FormControl<string>;
  [MCGRNewRequestControlName.MonumentRegistryDate]: FormControl<NgbDate>;
  [MCGRNewRequestControlName.DeterminationOfLocation]: FormControl<
    string | null
  >;
  [MCGRNewRequestControlName.JustificationOfImportance]: FormControl<string>;
  [MCGRNewRequestControlName.ContactPerson]: FormControl<string>;
  [MCGRNewRequestControlName.ApplicantAccountNumber]: FormControl<string>;
  [MCGRNewRequestControlName.LegalTitleToMonument]: FormControl<string>;
  [MCGRNewRequestControlName.LandAndMortgageRegisterNumberAndDocumentsCollectionNumber]: FormGroup<MCGRLandAndMortgageRegisterNumberAndDocumentsCollectionNumberFormGroup>;
  [MCGRNewRequestControlName.ConservationPermit]: FormGroup<MCGRConservationPermitFormGroup>;
  [MCGRNewRequestControlName.ConstructionPermit]: FormGroup<MCGRConstructionPermitFormGroup>;
  [MCGRNewRequestControlName.ScopeOfWorks]: FormControl<string>;
  [MCGRNewRequestControlName.JustificationOfWorksPurpose]: FormControl<string>;
  [MCGRNewRequestControlName.WorksDateRange]: FormControl<NgbDateRange>;
  [MCGRNewRequestControlName.FinancialSectorApplication]: FormArray<
    FormGroup<MCGRFinancialSectorApplicationFormGroup>
  >;
  [MCGRNewRequestControlName.WorksEstimatedCosts]: FormGroup<MCGREstimatedWorksCostsFormGroup>;
  [MCGRNewRequestControlName.MonumentCare]: FormControl<string>;
  [MCGRNewRequestControlName.HasBuildingBook]: FormControl<boolean>;
  [MCGRNewRequestControlName.HasAnnualTechInspections]: FormControl<boolean>;
  [MCGRNewRequestControlName.HasFiveYearTechInspections]: FormControl<boolean>;
  [MCGRNewRequestControlName.OtherActivities]: FormControl<string>;
  [MCGRNewRequestControlName.OtherConservationActivities]: FormArray<
    FormGroup<MCGROtherConservationActivitiesFormGroup>
  >;
  [MCGRNewRequestControlName.ExpenditureDeclaration]: FormControl<boolean>;
  [MCGRNewRequestControlName.AwarenessAndTruthfulnessDeclaration]: FormControl<boolean>;
}
